import { CatLoadingIndicator } from 'components/blocks-components';
import styles from './drawer-loader.module.scss';

export const DrawerLoader = ({ isLoading = false }: { isLoading: boolean }) => {
  return isLoading ? (
    <div
      data-testid="drawer-loader"
      className={`${styles['loader-indicator']} text-center`}
    >
      <CatLoadingIndicator />
    </div>
  ) : null;
};
